const toCompanySlug = (companyName: string): string =>
  companyName
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '') || 'company';

/** Public URL handed to viewers — the slug is cosmetic, `linkId` is what the server resolves. */
export const buildSharedCapTableUrl = (companyName: string, linkId: string): string =>
  `${window.location.origin}/share/${toCompanySlug(companyName)}/${linkId}`;
